import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import MenuAccessRoute from './components/MenuAccessRoute';
import MainLayout from './components/MainLayout';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Dashboard from './components/Dashboard';
import TableViewer from './components/TableViewer';
import TableForm from './components/TableForm';
import TablesList from './components/TablesList';
import Users from './components/Users';
import MenuManager from './components/MenuManager';
import MGBSetup from './components/MGBSetup';
import MenuManagement from './components/MenuManagement';
import AdminPanel from './components/AdminPanel';
import RelationshipVisualization from './components/RelationshipVisualization';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  // Initialize theme on app mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    document.documentElement.setAttribute('data-theme', savedTheme);
    document.body.className = `theme-${savedTheme}`;
  }, []);
  return (
    <Router basename="/aaimsdm">
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <MainLayout>
                  <Dashboard />
                </MainLayout>
              </PrivateRoute>
            } 
          />
          <Route 
            path="/tables/:tableName/add" 
            element={
              <PrivateRoute>
                <MainLayout>
                  <TableForm />
                </MainLayout>
              </PrivateRoute>
            } 
          />
          <Route 
            path="/tables/:tableName/edit/:recordId" 
            element={
              <PrivateRoute>
                <MainLayout>
                  <TableForm />
                </MainLayout>
              </PrivateRoute>
            } 
          />
          <Route 
            path="/tables/:tableName" 
            element={
              <PrivateRoute>
                <MainLayout>
                  <TableViewer />
                </MainLayout>
              </PrivateRoute>
            } 
          />
          <Route 
            path="/tables" 
            element={
              <PrivateRoute>
                <MainLayout>
                  <TablesList />
                </MainLayout>
              </PrivateRoute>
            } 
          />
          <Route 
            path="/users" 
            element={
              <PrivateRoute>
                <MainLayout>
                  <Users />
                </MainLayout>
              </PrivateRoute>
            } 
          />
          <Route path="/groups" element={<Navigate to="/dashboard" />} />
          <Route 
            path="/menus" 
            element={
              <PrivateRoute>
                <MenuAccessRoute menuName="Menus">
                  <MainLayout>
                    <MenuManager />
                  </MainLayout>
                </MenuAccessRoute>
              </PrivateRoute>
            } 
          />
          <Route 
            path="/mgb-setup" 
            element={
              <PrivateRoute>
                <MenuAccessRoute menuName="MGB Setup">
                  <MainLayout>
                    <MGBSetup />
                  </MainLayout>
                </MenuAccessRoute>
              </PrivateRoute>
            } 
          />
          <Route 
            path="/menu-management" 
            element={
              <PrivateRoute>
                <MenuAccessRoute menuName="Menu Management">
                  <MainLayout>
                    <MenuManagement />
                  </MainLayout>
                </MenuAccessRoute>
              </PrivateRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <PrivateRoute adminOnly={true}>
                <AdminPanel />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/relationships" 
            element={
              <PrivateRoute>
                <MainLayout>
                  <RelationshipVisualization />
                </MainLayout>
              </PrivateRoute>
            } 
          />
          <Route path="/settings" element={<Navigate to="/dashboard" />} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
